<template>
	<div @drop="onDrop" @dragover="preventDrag" @dragenter="onDragEnter" @dragleave="onDragLeave">
        <div class="text-center">
		</div>
		<!-- Swap Dialog -->
        <modal
            :hideFooter="true"
            class="swap-modal"
            size="medium"
            @close="close"
            v-if="isShowMisc">
            <template slot="header">
				{{ $t('Misc Files') }}
            </template>
            <template slot="body">
                <div class="body-misc">
                    <!-- body -->
                    <div class="d-flex justify-content-between">
                        <div class="relative d-flex">
                            <i class="material-icons wrapper-search-input ml-2">search</i>
                            <input
                                type="text"
                                class="form-control search-input"
                                :placeholder="$t('Search Misc')"
                                @input="onKeywordChange"
                                v-model="keyword"
                                :disabled="isFetching"
                                autofocus
                            />
							<label
								class="ml-2 btn btn-submit btn-primary text-center" :class="{'disabled': isFetching || isAdding || isUploading}">
								<span>{{ $t('Add File(s)') }}</span>
									<input
										id="miscInput"
										:accept="acceptedFileTypes"
										type="file"
										class="hidden"
										multiple
										@change="fileMultipleUpload"
									/>
							</label>
						</div>

						<button class="btn btn-primary" style="height: 34px" :class="{'disabled': isFetching || isAdding || isUploading || isSharing, 'is-loading': isSharing}" @click="sharingMisc()">
							<div class="d-flex">
								{{ $t('SHARED FOLDER') }}
								<div class="icon-misc pl-0 ml-2">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z" /></svg>
								</div>
							</div>

						</button>
                    </div>
                    <!-- main content -->
					<div class="p-5 text-center absolute" v-if="isFetching">
						<div class="is-loading large"></div>
					</div>
                    <DropArea ref="dndElement" v-show="!isFetching && items && items.length === 0 && !keyword" @fileMultipleUpload="fileMultipleUpload" :class="{'disabled': isFetching || isAdding || isUploading}"></DropArea>
                    <div style="max-height: 390px; overflow-y: auto;" class="mt-4" v-show="!isFetching && items && items.length > 0">
                        <table class="table table-striped" style="padding: 0;" >
                            <tbody v-if="!isFetching">
                                <tr
                                    class="relative pointer"
                                    v-for="(item) in items"
                                    :key="item.id" @dblclick="openModalEdit(item)"
									@mouseover="itemHover(item)" @mouseleave="itemLeave(item)" @mousemove="updateTooltipPosition">
                                    <td style="padding: 13px" >
                                        <div class="icon-misc" v-if="item && item.description && item.description.includes('pdf')">
                                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#EA444A" d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9.5 11.5C9.5 12.3 8.8 13 8 13H7V15H5.5V9H8C8.8 9 9.5 9.7 9.5 10.5V11.5M14.5 13.5C14.5 14.3 13.8 15 13 15H10.5V9H13C13.8 9 14.5 9.7 14.5 10.5V13.5M18.5 10.5H17V11.5H18.5V13H17V15H15.5V9H18.5V10.5M12 10.5H13V13.5H12V10.5M7 10.5H8V11.5H7V10.5Z" /></svg>
                                        </div>
                                        <div class="icon-misc" v-else-if="item && item.description && item.description.includes('video')">
                                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#C1C629" d="M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z" /></svg>
                                        </div>
                                        <div class="icon-misc" v-else-if="item && item.description && item.description.includes('audio')">
                                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#FFC0CB" d="M21,3V15.5A3.5,3.5 0 0,1 17.5,19A3.5,3.5 0 0,1 14,15.5A3.5,3.5 0 0,1 17.5,12C18.04,12 18.55,12.12 19,12.34V6.47L9,8.6V17.5A3.5,3.5 0 0,1 5.5,21A3.5,3.5 0 0,1 2,17.5A3.5,3.5 0 0,1 5.5,14C6.04,14 6.55,14.12 7,14.34V6L21,3Z" /></svg>
                                        </div>
                                        <div class="icon-misc" v-else-if="item && item.description && item.description.includes('image')">
                                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#3087F9" d="M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z" /></svg>
                                        </div>
                                        <div class="icon-misc" v-else-if="item && item.description && item.description.includes('sheet') || item && item.description && item.description.includes('spreadsheetml')">
                                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#37E723" d="M19,11V9H11V5H9V9H5V11H9V19H11V11H19M19,3C19.5,3 20,3.2 20.39,3.61C20.8,4 21,4.5 21,5V19C21,19.5 20.8,20 20.39,20.39C20,20.8 19.5,21 19,21H5C4.5,21 4,20.8 3.61,20.39C3.2,20 3,19.5 3,19V5C3,4.5 3.2,4 3.61,3.61C4,3.2 4.5,3 5,3H19Z" /></svg>
                                        </div>
                                        <div class="icon-misc" v-else-if="item && item.name && item.name.includes('.rar') || item && item.description && item.description.includes('compressed')">
                                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#06BDFF" d="M14,17H12V15H10V13H12V15H14M14,9H12V11H14V13H12V11H10V9H12V7H10V5H12V7H14M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z" /></svg>
                                        </div>
                                        <div class="icon-misc" v-else-if="item && item.description && item.description.includes('presentation') || item && item.description && item.description.includes('presentationml')">
                                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#D872F7" d="M9.8,13.4H12.3C13.8,13.4 14.46,13.12 15.1,12.58C15.74,12.03 16,11.25 16,10.23C16,9.26 15.75,8.5 15.1,7.88C14.45,7.29 13.83,7 12.3,7H8V17H9.8V13.4M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5C3,3.89 3.9,3 5,3H19M9.8,12V8.4H12.1C12.76,8.4 13.27,8.65 13.6,9C13.93,9.35 14.1,9.72 14.1,10.24C14.1,10.8 13.92,11.19 13.6,11.5C13.28,11.81 12.9,12 12.22,12H9.8Z" /></svg>
                                        </div>
                                        <div class="icon-misc" v-else-if="item && item.description && item.description.includes('wordprocessingml') || item && item.description && item.description.includes('text/plain')">
                                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#B6EBFF" d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15,18V16H6V18H15M18,14V12H6V14H18Z" /></svg>
                                        </div>
                                        <div class="icon-misc" v-else>
                                            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#B6EBFF" d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V4C4,2.89 4.89,2 6,2M15,18V16H6V18H15M18,14V12H6V14H18Z" /></svg>
                                        </div>
                                    </td>
                                    <td style="padding: 13px" width="60%" >{{ item.name }}</td>
                                    <td style="padding: 13px" width="30%" class="btn-action-table" >
                                        <button v-if="hover && hoverItem === item.id"
                                            class="btn btn-default btn-icon mr-3"
                                            @click="downloadMedia(item.path)">
                                            <i class="material-icons md-18">download</i>
                                        </button>
										<button v-if="hover && hoverItem === item.id"
                                            class="btn btn-default btn-icon mr-3"
                                            @click="openModalEdit(item)">
                                            <i class="material-icons md-18">edit</i>
                                        </button>
                                        <button v-if="hover && hoverItem === item.id"
                                            class="btn btn-danger btn-icon"
                                            @click="confirmRemoveItem(item)">
                                            <i class="material-icons md-18">delete</i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
						<div v-if="isTooltipVisible && tooltipNote" class="tooltip-misc" :style="{ top: `${tooltipPosition.y}px`, left: `${tooltipPosition.x}px` }">
							{{ tooltipNote }}
						</div>
                    </div>
                </div>
                <div v-if="!isFetching && items && items.length === 0 && !isUploading" class="footer-misc">
                    {{ $t('No file available') }}
                </div>
                <div class="footer-misc" v-if="!isFetching && items && items.length > 0 && !isUploading">
                    {{ items && items.length }} {{ $t('File(s)') }}
                </div>
                <div class="footer-misc" v-if="isAdding || isUploading">
                    <div>{{ $t('Uploading') }} {{uploadProgress}} % ({{fileCount}}/{{fileCountTotal}})</div>
                </div>
            </template>
		</modal>

        <!-- Delete Confirmation -->
        <modal
            size="small"
            class="template-modal gallery-modal-delete"
            @close="isConfirmRemoveVisible = false"
            v-if="isConfirmRemoveVisible">
            <template slot="header">
                {{ $t('Confirm Delete') }}
            </template>
            <template slot="body">
                A<span class="lowercase pr-1">{{ $t('re you sure want to delete') }}</span><span class="capitalize">{{showModalName(selected ? selected.name : '') }}?</span>
            </template>
            <template slot="footer">
                <div class="w-100 flex-center">
                    <button class="btn btn-primary" :class="{ 'is-loading': isDeleting }" @click="remove">
                        {{ $t('Yes, Delete It') }}
                    </button>
                    <button class="btn btn-default" @click="isConfirmRemoveVisible = false">
                        {{ $t('Cancel') }}
                    </button>
                </div>
            </template>
        </modal>

		<!-- modal Edit -->
		<modal
            size="small-medium"
            class="template-modal gallery-modal-delete"
            @close="closeEdit()"
            v-if="isShowEdit">
            <template slot="header">
                {{ $t('Edit File') }}
            </template>
            <template slot="body">
                <div class="form-group">
					<label class="text-primary">{{ $t('Name') }}</label>
					<input type="text" name="name" class="form-control" @keydown="handleKeydown" v-model="name" required>
					<span v-if="name === ''" class="text-danger text-small">{{$t('Name cannot be empty')}}</span>
				</div>
				<div class="form-group">
					<label class="text-primary">{{ $t('Note') }}</label>
					<textarea type="text" name="note" rows="8" class="form-control" maxlength="455"
						v-model="note">
					</textarea>
				</div>
            </template>
            <template slot="footer">
                <div class="w-100 flex-center">
                    <button class="btn btn-primary" :disabled="!name" :class="{ 'is-loading': isUpdating }" @click="updateMedia()">
                        {{ $t('Save') }}
                    </button>
                    <button class="btn btn-default" @click="closeEdit()">
                        {{ $t('Cancel') }}
                    </button>
                </div>
            </template>
        </modal>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import DropArea from '@/components/DropArea.vue';
import mediasApi from '@/api/medias';
import fileApi from '@/api/file';
import {
	getAxiosErrorMessage, delay, duplicateVar, elpisisString, copyToClipboard,
} from '@/lib/helper';

export default {
	name: 'ModalRundownMisc',
	components: {
		Modal,
		DropArea,
	},
	props: {
		isShowMisc: {
			type: Boolean,
		},
		rundownId: {
			type: Number,
		},
		rundown: {
			type: Object,
		},
	},
	created() {
		if (this.clientUser) {
			this.localClientUser = this.clientUser;
		}
	},
	watch: {
		isShowMisc() {
			this.fetch();
		},
	},
	mounted() {
	},
	data: () => ({
		page: 1,
		orderBy: 'created_at',
		sortBy: 'desc',
		keyword: '',
		items: [],
		totalItems: 0,
		lastPage: 0,
		isFetching: false,

		// upload
		isUploading: false,
		uploadProgress: 0,
		isAdding: false,
		// multiple upload
		fileCount: 0,
		fileCountTotal: 0,
		tmpCount: 0,
		// loader
		fullPage: true,
		colorOverlay: '#000000',
		colorLoading: '#FFFFFF',
		// selecting misc
		selected: null,
		rundownItem: null,
		// deleting misc
		isDeleting: false,
		isShowDelete: false,
		isConfirmRemoveVisible: false,
		// user data
		settings: null,
		uploadLimit: '',
		isEnableUploadLimit: false,
		// storage warn
		isStorage99Percent: false,
		isStorage80Percent: false,
		currentStorage: false,
		availableStorage: false,
		// hover
		hover: false,
		hoverItem: null,
		// accepted files
		acceptedFileTypes: [
			'application/pdf',
			'application/vnd.ms-excel',
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			'application/msword',
			'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
			'application/vnd.ms-powerpoint',
			'application/vnd.openxmlformats-officedocument.presentationml.presentation',
			'application/xml',
			'text/xml',
			'text/plain',
			'audio/mpeg',
			'audio/wav',
			'video/mp4',
			'video/quicktime',
			'application/zip',
			'application/x-zip-compressed',
			'image/gif',
			'image/png',
			'image/jpeg',
			'image/jpg',
			'image/tiff',
			'image/tif',
			'image/psd',
			'image/svg+xml',
			'image/bmp',
			'application/vnd.oasis.opendocument.presentation',
			'application/vnd.ms-powerpoint',
			'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
			'application/vnd.oasis.opendocument.spreadsheet',
			'video/mpeg',
			'video/webm',
			'text/rtf',
		],

		// edit media
		isShowEdit: false,
		isUpdating: false,
		name: '',
		note: '',
		currentExtension: '',

		// tooltip
		isTooltipVisible: false,
		tooltipPosition: { x: 0, y: 0 },
		tooltipContent: null,

		// sharing misc
		isSharing: false,
	}),
	methods: {
		itemLeave() {
			this.hover = false;
			this.hoverItem = null;
			this.isTooltipVisible = false;
			this.tooltipContent = null;
		},
		itemHover(item) {
			let delayTooltip = 0;
			if (!this.hoverItem) delayTooltip = 1000;
			if (this.hoverItem !== item.id) delayTooltip = 1000;
			if (this.hoverItem === item.id) delayTooltip = 0;
			this.tooltipContent = item.content;
			delay(() => {
				this.isTooltipVisible = true;
			}, delayTooltip);
			this.hover = true;
			this.hoverItem = item.id;
		},
		handleKeydown(event) {
			// Prevent typing or pasting dots
			if (event.key === '.') {
				event.preventDefault();
			}
		},
		updateTooltipPosition(event) {
			this.tooltipPosition = { x: event.pageX, y: event.pageY + 28 }; // Adjust 28px for spacing
		},
		close() {
			this.$emit('close');
		},
		fetch(reset = false, page) {
			this.isFetching = true;
			if (reset) {
				this.page = 1;
				this.items = [];
			}
			if (page) this.page = page;
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
				type: 'misc',
				rundown_id: this.rundownId,
				keyword: this.keyword,
			};
			const callback = (response) => {
				const items = response.data;
				this.items = items;
				this.totalItems = response.total;
				this.lastPage = response.lastPage;
				this.isFetching = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Users',
					text: message,
				});
				this.isFetching = false;
			};
			mediasApi.getList(params, callback, errorCallback);
		},
		onKeywordChange() {
			delay(() => {
				this.fetch(true);
			}, 1000);
		},

		insertItems(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				this.items.push(item);
			}
		},
		fileMultipleUpload(e) {
			const files = e && e.target && e.target.files ? e.target.files : e;
			if (files.length) {
				this.fileCountTotal = files.length;
				for (let index = 0; index < files.length; index++) {
					const element = files[index];
					this.onFileSelected(element);
				}
			}
		},
		onFileSelected(fileItem) {
			this.initDataUser();
			this.availableStorage = 0;
			this.currentStorage = 0;
			// get data max upload
			const oneMB = 1048576; // MB
			if (!this.isEnableUploadLimit) {
				this.uploadLimit = 1048;
			}
			const fileSizeInMb = fileItem.size / oneMB;
			const oneGB = 1048;

			if (!this.isValidFileType(fileItem)) {
				this.$notify({
					group: 'app',
					type: 'warning',
					title: 'Upload Media',
					text: 'Unsupported file',
				});
				// Reset the input to clear the selected file
				document.querySelector('#miscInput').value = '';
				return; // Stop processing if an invalid file is found
			}
			// upload
			if (fileSizeInMb <= oneGB) {
				if (fileSizeInMb <= this.uploadLimit) {
					// if inside rundown
					if (this.rundownStorage && !this.isSuperAdmin) {
						const resultSizeFile = fileItem.size / oneMB;
						const isRemainingStorageAvailable = this.rundownStorage.total_remaining_size >= 0 && this.rundownStorage.total_remaining_size >= resultSizeFile;
						const nomalizedTotalRemaining = this.rundownStorage.total_remaining_size <= 0 ? 0 : this.rundownStorage.total_remaining_size;
						// automatically reject, over limit
						if (!isRemainingStorageAvailable) {
							const message = `Your total used Storage is ${this.rundownStorage.total_used_file_size} MB, your currennt remaining size is ${nomalizedTotalRemaining.toFixed(2)}MB`;
							this.$notify({
								group: 'app',
								type: 'warning',
								title: 'Upload Media',
								text: message,
							});
							// files = null;
							this.isCached = false;
							this.isCaching = false;
							if (document.querySelector('#miscInput')) document.querySelector('#miscInput').value = '';
							return;
						}
					}
					// start upload
					if (!this.items.some(data => data.name === fileItem.name) && !this.items.some(data => data.size === fileItem.size)) {
						const file = fileItem;
						if (!file) {
							this.$notify({
								group: 'app',
								type: 'warn',
								title: 'Upload Media',
								text: 'Sorry, currently we cant upload the file',
							});
							return;
						}

						this.isUploading = true;
						this.mediaFile = file;
						// Remove extension from filename to set label
						const filename = duplicateVar(file.name);
						const fileSize = file.size;
						const description = file.type;
						this.mediaLabel = duplicateVar(filename);

						const params = new FormData();
						params.append('file', file);
						if (this.rundownId) params.append('rundown_id', this.rundownId);
						const callback = async (response) => {
							const miscUrl = response.data;
							this.showUploadModal = false;
							this.uploadProgress = 100;
							this.addMedia(file.name, 'misc', miscUrl, fileSize, description);
							document.querySelector('#miscInput').value = '';
							if (this.rundownStorage) {
								// on the spot 100%
								const resultSizeFile = file.size / oneMB;
								// eslint-disable-next-line
								const isStorageOnTheSpot100 = this.rundownStorage.total_remaining_size === resultSizeFile;
								// right on 80% mark
								const resultPercentage80 = this.rundownStorage.total_max_file_size * 80 / 100;
								const fixTotalUsageAndFile80 = (this.rundownStorage.total_used_file_size + resultSizeFile).toFixed(4);
								// eslint-disable-next-line
								const isStorageOnTheSpot80 = fixTotalUsageAndFile80 >= resultPercentage80 && this.rundownStorage.total_used_file_size < resultPercentage80;
								// right on 99% mark
								const resultPercentage99 = this.rundownStorage.total_max_file_size * 99 / 100;
								const fixTotalUsageAndFile99 = (this.rundownStorage.total_used_file_size + resultSizeFile).toFixed(4);
								// eslint-disable-next-line
								const isStorageOnTheSpot99 = fixTotalUsageAndFile99 >= resultPercentage99 && this.rundownStorage.total_used_file_size < resultPercentage99;
								if (isStorageOnTheSpot100) {
									const message = 'Your total used Storage is 100%';
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
								} else if (isStorageOnTheSpot99) {
									const message = 'Your total used Storage is over 99%';
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
									this.isStorage99Percent = true;
									this.currentStorage = this.rundownStorage.total_max_file_size - resultPercentage99;
									this.availableStorage = this.rundownStorage.total_max_file_size;
								} else if (isStorageOnTheSpot80) {
									const message = 'Your total used Storage is over 80%';
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Media',
										text: message,
									});
									this.isStorage80Percent = true;
									this.currentStorage = this.rundownStorage.total_max_file_size - resultPercentage80;
									this.availableStorage = this.rundownStorage.total_max_file_size;
								}
							}
						};
						const errorCallback = (e) => {
							const message = getAxiosErrorMessage(e);
							this.$notify({
								group: 'app',
								type: 'error',
								title: 'Upload Media',
								text: message,
							});
							this.availableStorage = 0;
							this.currentStorage = 0;
						};
						const progressCallback = (progress) => {
							this.uploadProgress = progress;
						};
						fileApi.upload(params, callback, errorCallback, progressCallback);
					} else {
						this.tmpCount += 1;
						this.fileCount = this.fileCountTotal - (this.fileCountTotal - this.tmpCount);
						if (this.tmpCount === this.fileCountTotal) {
							this.isUploading = false;
							this.fileCount = 0;
							this.tmpCount = 0;
						}
						this.$notify({
							group: 'app',
							type: 'error',
							text: 'File already exist, please upload another file',
						});
					}
				} else {
					document.querySelector('#miscInput').value = '';
					const appUrl = process.env.VUE_APP_URL;
					this.$notify({
						group: 'app',
						type: 'error',
						text: `You current package upload limit is ${this.uploadLimit} MB, <a href="${appUrl}/settings?menu=subscribe"> Upgrade your subscription </a>`,
					});
				}
			} else {
				document.querySelector('#miscInput').value = '';
				this.$notify({
					group: 'app',
					type: 'error',
					text: 'Max upload limit is 1GB',
				});
			}
		},

		isValidFileType(file) {
			// Get the file type (MIME type)
			const fileType = file.type;

			// Check if the file type is in the acceptedFileTypes array
			return this.acceptedFileTypes.includes(fileType);
		},

		addMedia(name, type, url, size, description) {
			const oneMB = 1048576; // MB
			this.isAdding = true;

			const params = {
				name,
				path: url,
				type,
				thumbnail: this.mediaThumbnail,
				size: size / oneMB,
				description,
			};
			params.rundown_id = this.rundownId;

			const callback = (response) => {
				const item = response.data;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Media',
					text: response.message,
				});
				this.tmpCount += 1;
				this.fileCount = this.fileCountTotal - (this.fileCountTotal - this.tmpCount);
				if (this.tmpCount === this.fileCountTotal) {
					this.isUploading = false;
					this.fileCount = 0;
					this.tmpCount = 0;
				}

				this.isAdding = false;
				this.isUploadModal = false;
				this.items.unshift(item);
				document.querySelector('#miscInput').value = '';
				this.assetsUrl = null;
				if (this.isStorage80Percent || this.isStorage99Percent) this.notifyEmailStorage();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
				this.isAdding = false;
			};
			mediasApi.create(params, callback, errorCallback);
		},

		downloadMedia(url) {
			window.open(url);
		},

		confirmRemoveItem(item) {
			this.selected = item;
			this.isConfirmRemoveVisible = true;
		},
		showModalName(str) {
			return elpisisString(str);
		},

		remove() {
			if (!this.selected) return;
			this.isDeleting = true;
			const id = this.selected.id;

			const callback = (response) => {
				this.removeItem(id);
				// const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Delete Media',
					text: 'File has been deleted',
				});
				this.isDeleting = false;
				this.isConfirmRemoveVisible = false;
				this.selected = null;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Delete Media',
					text: message,
				});
				this.isConfirmRemoveVisible = false;
				this.isDeleting = false;
			};
			mediasApi.delete(id, callback, errorCallback);
		},
		removeItem(itemId) {
			const index = this.items.findIndex(({ id }) => id === itemId);
			if (index !== -1) {
				this.items.splice(index, 1);
				document.querySelector('#miscInput').value = '';
			}
		},

		initDataUser() {
			if (this.user) {
				const settingsString = this.user && this.user.settings ? this.user.settings : '';
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				const isSuperAdmin = this.isSuperAdmin || null;// check the computed import the getters befor implement
				const isCollaborator = this.isCollaborator || null;// check the computed import the getters befor implement
				const isClient = this.isClient || null;// check the computed import the getters befor implement
				if (!isSuperAdmin && isClient) { // not admin and can be collaborator and client who have two roles
					this.isEnableUploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.is_enabled ? duplicateVar(settings.subscription.storage.is_enabled) : false;
					this.uploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.upload_size ? duplicateVar(settings.subscription.storage.upload_size) : 10;
				} else if ((!isSuperAdmin && isCollaborator && !isClient)) { // only for collaborator that invited by client
					if (this.localClientUser) {
						const userClientSettingsString = this.localClientUser && this.localClientUser.settings ? this.localClientUser.settings : '';
						const userClientSettings = JSON.parse(userClientSettingsString);
						this.isEnableUploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.is_enabled ? duplicateVar(userClientSettings.subscription.storage.is_enabled) : false;
						this.uploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.upload_size ? duplicateVar(userClientSettings.subscription.storage.upload_size) : 10;
					}
				} else { // for superadmin only
					this.isEnableUploadLimit = false;
					this.uploadLimit = 1048;
				}
			}
		},

		openModalEdit(item) {
			this.selected = item;
			const oriName = item && item.name ? item.name : '';
			const lastIndex = oriName.lastIndexOf('.');
			const filenameWithoutExtension = oriName.substring(0, lastIndex);
			this.currentExtension = oriName.substring(lastIndex + 1);

			this.name = filenameWithoutExtension;
			const content = item && item.content ? JSON.parse(item.content) : null;
			this.note = content && content.note ? content.note : '';
			this.isShowEdit = true;
		},

		closeEdit() {
			this.selected = null;
			this.name = '';
			this.note = '';
			this.isShowEdit = false;
		},

		updateMedia() {
			this.isUpdating = true;
			const callback = (response) => {
				const item = response.data;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Media',
					text: response.message,
				});
				this.insertItem(item);
				this.isUpdating = false;
				this.isShowEdit = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
				this.isShowEdit = false;
			};
			const content = {
				note: this.note,
			};
			const params = {
				name: `${this.name}.${this.currentExtension}`,
				content: JSON.stringify(content),
			};
			mediasApi.update(this.selected.id, params, callback, errorCallback);
		},

		insertItem(item) {
			const index = this.items.findIndex(({ id }) => id === item.id);
			if (index === -1) {
				this.items.push(item);
			} else {
				this.$set(this.items, index, item);
			}
		},

		sharingMisc() {
			this.isSharing = true;
			const callback = (response) => {
				const item = response.data;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Media',
					text: response.message,
				});
				copyToClipboard(item);
				this.isSharing = false;
				this.isShowEdit = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
				this.isShowEdit = false;
			};
			mediasApi.generateUrl(this.rundownId, callback, errorCallback);
		},

		onDrop(event) {
			if (!this.isFetching && this.items && this.items.length > 0) this.$refs.dndElement.onDrop(event);
		},
		preventDrag(event) {
			if (!this.isFetching && this.items && this.items.length > 0) this.$refs.dndElement.preventDrag(event);
		},
		onDragEnter() {
			if (!this.isFetching && this.items && this.items.length > 0) this.$refs.dndElement.onDragEnter();
		},
		onDragLeave() {
			if (!this.isFetching && this.items && this.items.length > 0) this.$refs.dndElement.onDragLeave();
		},
	},
	beforeDestroy() {
	},
	computed: {
		...mapGetters({
			user: 'user',
			clientUser: 'clientUser',
			isClient: 'isClient',
			isSuperAdmin: 'isSuperAdmin',
			isCollaborator: 'isCollaborator',
		}),
		rundownStorage() {
			return {
				total_max_file_size: this.rundown && this.rundown.total_max_file_size ? this.rundown.total_max_file_size : 0,
				total_remaining_size: this.rundown && this.rundown.total_remaining_size ? this.rundown.total_remaining_size : 0,
				total_used_file_size: this.rundown && this.rundown.total_used_file_size ? this.rundown.total_used_file_size : 0,
			};
		},
		tooltipNote() {
			const note = JSON.parse(this.tooltipContent);
			return note && note.note ? note.note : '';
		},
	},
};
</script>
